export default "__VITE_ASSET__BlQIMpyu__"